import { AppSettings } from "@/settings"

/**
 * Einza api service class
 *
 * Sets headers and based on the requested method retuns the response or throws error
 */
class _EinzaApiService {
  // common prefix for all requests
  #endPointPrefix = "shop/api/prgruppen"
  #config = {}
  #headers = {}

  constructor() {
    this.#config = AppSettings.einzaApiConfig()
    this.#headers = this.#setHeaders()
  }

  /**
   * Provided the method, fires request and returns promise of the response.json() object
   *
   * @param {string} method
   */
  async getData(method) {
    try {
      const request = await this.#setRequest(method)

      return await request.json()
    } catch (error) {
      throw new Error(error)
    }
  }

  #setHeaders() {
    const { apiPassword, apiUser } = this.#config

    return new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Basic ${btoa(`${apiUser}:${apiPassword}`)}`,
    })
  }

  /**
   * Sets the request with headers, endpoint, prefix and method
   *
   * @param {string} method
   */
  async #setRequest(method) {
    if (!method) throw new Error("Missing method")

    const { apiEndpoint } = this.#config
    const prefix = this.#endPointPrefix
    const request = await fetch(`${apiEndpoint}/${prefix}/${method}`, {
      headers: this.#headers,
      method: "GET",
    })

    return request
  }
}

export const EinzaApiService = new _EinzaApiService()
